import { render, staticRenderFns } from "./MultiChoiceAnswer.vue?vue&type=template&id=32c9678d&scoped=true"
import script from "./MultiChoiceAnswer.vue?vue&type=script&lang=js"
export * from "./MultiChoiceAnswer.vue?vue&type=script&lang=js"
import style0 from "./MultiChoiceAnswer.vue?vue&type=style&index=0&id=32c9678d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c9678d",
  null
  
)

export default component.exports